import { Alert, styled } from '@mui/material';
import { alertClasses } from '@mui/material/Alert';
import { buttonClasses } from '@mui/material/Button';

const StyledAlert = styled(Alert)(({ theme }) => ({
  borderRadius: '12px',
  // Toast informativo (ej. permitir notificaciones push) en monocromo: superficie
  // oscura neutra, texto blanco y acento dorado solo en el ícono y la acción.
  [`&.${alertClasses.filledInfo}`]: {
    backgroundColor: theme.palette.surface.raised,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.hairline.main}`,
    boxShadow: 'var(--otx-card-shadow)',
    [`& .${alertClasses.icon}`]: {
      color: theme.palette.gold.main
    },
    [`& .${alertClasses.action} .${buttonClasses.root}`]: {
      color: theme.palette.gold.main,
      fontWeight: 700
    }
  },
  [theme.breakpoints.down('sm')]: {
    [`& .${alertClasses.icon}`]: {
      fontSize: theme.typography.pxToRem(18)
    },
    [`& .${alertClasses.message}`]: {
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${alertClasses.action}`]: {
      paddingTop: '2px',
      [`& .${buttonClasses.root}`]: {
        fontSize: theme.typography.pxToRem(12)
      }
    }
  }
}));

export default StyledAlert;
